import 'react-image-gallery/styles/css/image-gallery.css';

import ImageGallery from 'react-image-gallery';
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import classNames from 'classnames/bind';
import styles from './ImagesGallery.module.scss';

const cx = classNames.bind(styles);

function ImagesGallery(props) {
  const [images, setImages] = React.useState(null);

  React.useEffect(() => {
    let shouldCancel = false;

    const call = async () => {
      if (!shouldCancel && props.Images && props.Images.length > 0) {
        setImages(
          props.Images.map((e, idx) => ({
            original: `${e.image}`,
            thumbnail: `${e.image}`,
          })),
        );
      }
    };
    call();
    return () => (shouldCancel = true);
  }, []);

  return images ? (
    <ImageGallery
      items={images}
      infinite={false}
      showIndex={true}
      showFullscreenButton={false}
      showPlayButton={false}
      lazyLoad={true}
    />
  ) : null;
}

export default ImagesGallery;
